/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  ${css($.positions.map(position => `
    .position-${position} { 
      position: ${position} !important; 
    }
  `))}

  .fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: ${$.zindexFixed};
  }

  .fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${$.zindexFixed};
  }

  .sticky-top {
    @supports (position: sticky) {
      position: sticky;
      top: 0;
      z-index: ${$.zindexSticky};
    }
  }
`;
